import { module } from 'angular';

import { default as popupGiveupName, PopupGiveup } from './popup-giveup.component';

export default module('contact.agent.core.contact.giveup', []).component(popupGiveupName, new PopupGiveup()).name;
